export default function setColorsFromThemeJsonTS(enterprise: string) {
    let cssId = enterprise + "_css";
    if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `themes/${enterprise}/css/color.css`;
        link.media = 'all';
        link.onerror = () => {
            console.error(`Failed to load theme CSS for ${enterprise}, retrying...`);
            link.remove();
            setTimeout(() => {
                if (!document.getElementById(cssId)) {
                    var retryLink = document.createElement('link');
                    retryLink.id = cssId;
                    retryLink.rel = 'stylesheet';
                    retryLink.type = 'text/css';
                    retryLink.href = `themes/${enterprise}/css/color.css?t=${Date.now()}`;
                    retryLink.media = 'all';
                    head.appendChild(retryLink);
                    document.getElementsByTagName('body')[0].classList.add(enterprise);
                }
            }, 2000);
        };
        head.appendChild(link);
        document.getElementsByTagName('body')[0].classList.add(enterprise);
    }
    let favIcon = document.getElementById("favIcon");
    if(favIcon){
        favIcon.setAttribute("href",`themes/${enterprise}/favicon.ico`);
    }
}